import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { Role } from '@shared/data-access/data-access-authentication';

import { RoleDirective } from '../../../directives/role.directive';

@Component({
  selector: 'app-welcome-banner',
  imports: [TranslocoPipe, RouterLink, RoleDirective],
  templateUrl: './welcome-banner.component.html',
  styleUrl: './welcome-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomeBannerComponent {
  firstName = input.required<string>();

  Role = Role;
}
